import React, { useState, useEffect } from 'react';
import type { IProps } from './plans-section-container';
import { getDialerPlanData } from './utils/helper';
import { getPlanMode } from '../../../select-plan/utils/helper';
import { isRequestPending } from '../../../../utils/helper';
import DialerPlanCard from '../dialer-plan-card';

const PlansSection: React.FC<IProps> = ({
  planCycle,
  onSelectPlan,
  selectedPlanId,
  //* API Request State
  sendGetDialerPlansResponse,
  sendGetDialerSubscriptionResponse,
  sendGetPurchaseDialerModifySubscriptionRequestStatus,
  isPaddlePolling,
}) => {
  const isPurchaseInProgress = isRequestPending(
    sendGetPurchaseDialerModifySubscriptionRequestStatus,
  );

  //* states
  const [planData, setPlanData] = useState([]);

  //* useEffect
  useEffect(() => {
    if (sendGetDialerPlansResponse) {
      setPlanData([
        ...getDialerPlanData(
          getPlanMode(planCycle),
          sendGetDialerPlansResponse,
        ),
      ]);
    }
  }, [planCycle, sendGetDialerPlansResponse, sendGetDialerSubscriptionResponse]);

  return (
    <div className="d-flex justify-content-between align-items-end dialer-plans-card-container mt-4">
      {planData?.map((plan) => (
        <DialerPlanCard
          key={plan?.id}
          plan={plan}
          planCycle={planCycle}
          handlePlanSelect={(planId, planName) =>
            onSelectPlan(planId, planName)
          }
          sendGetDialerSubscriptionResponse={sendGetDialerSubscriptionResponse}
          sendGetDialerPlansResponse={sendGetDialerPlansResponse}
          isPurchaseInProgress={
            (isPurchaseInProgress && selectedPlanId === plan?.id) ||
            isPaddlePolling
          }
        />
      ))}
    </div>
  );
};

export default PlansSection;
